(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colecciones-3d"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('r68-collections')) {
  customElements.define('r68-collections', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.initTimer = setTimeout(() => this.init(), 0);
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.sourceList = this.querySelector('.r68c__sources');
      if (!this.sourceList) return;
      this.sources = Array.from(this.sourceList.children);
      this.total = this.sources.length;
      if (!this.total) return;
      this.stage = this.querySelector('.r68c__stage');
      this.controls = this.querySelector('.r68c__controls');
      this.counter = this.querySelector('.r68c__counter');
      this.status = this.querySelector('.r68c__sr');
      this.index = 0;
      this.busy = false;
      this.controller = new AbortController();
      const opts = {signal: this.controller.signal};
      this.stage.replaceChildren();
      this.nodes = [];
      const slots = this.total === 1 ? [0] : [-2,-1,0,1,2];
      slots.forEach(slot => this.addCard(slot));
      this.sourceList.hidden = true;
      this.stage.hidden = false;
      this.controls.hidden = this.total < 2;
      this.updateStatus(false);
      this.controls.addEventListener('click', e => {
        const button = e.target.closest('[data-dir]');
        if (button) this.move(Number(button.dataset.dir));
      }, opts);
      this.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        this.move(e.key === 'ArrowRight' ? 1 : -1, this.stage.contains(document.activeElement));
      }, opts);
      this.stage.addEventListener('dragstart', e => e.preventDefault(), opts);
      this.stage.addEventListener('pointerdown', e => {
        if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
        this.start = {id:e.pointerId,x:e.clientX,y:e.clientY};
      }, opts);
      window.addEventListener('pointerup', e => {
        if (!this.start || this.start.id !== e.pointerId) return;
        const dx = e.clientX - this.start.x, dy = e.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 38 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.suppressClickUntil = Date.now() + 450;
          this.move(dx < 0 ? 1 : -1);
        }
      }, opts);
      window.addEventListener('pointercancel', () => { this.start = null; }, opts);
      this.stage.addEventListener('click', e => {
        if (Date.now() < (this.suppressClickUntil || 0) || this.busy) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, {...opts,capture:true});
    }
    wrap(n) { return (n % this.total + this.total) % this.total; }
    addCard(slot) {
      const card = this.sources[this.wrap(this.index + slot)].cloneNode(true);
      card.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.draggable = false; });
      this.stage.append(card);
      this.nodes.push(card);
      this.position(card, slot);
      return card;
    }
    position(card, slot) {
      card.dataset.slot = slot;
      const central = slot === 0;
      const visible = Math.abs(slot) < 2 && !(this.total === 2 && slot === -1);
      const scale = central ? 1 : .68;
      card.style.transform = `translateX(-50%) translateX(${slot * 59}%) scale(${scale})`;
      card.style.opacity = visible ? (central ? '1' : '.55') : '0';
      card.style.zIndex = central ? '3' : (visible ? '2' : '0');
      card.style.pointerEvents = visible ? 'auto' : 'none';
      card.inert = !visible;
      card.tabIndex = visible ? 0 : -1;
      card.setAttribute('aria-hidden', String(!visible));
    }
    move(direction, restoreFocus = false) {
      if (this.busy || this.total < 2) return;
      this.busy = true;
      this.index = this.wrap(this.index + direction);
      this.nodes.forEach(card => this.position(card, Number(card.dataset.slot) - direction));
      this.updateStatus(true);
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 480;
      this.finishTimer = setTimeout(() => {
        const obsolete = this.nodes.filter(card => Math.abs(Number(card.dataset.slot)) > 2);
        obsolete.forEach(card => card.remove());
        this.nodes = this.nodes.filter(card => !obsolete.includes(card));
        this.addCard(direction * 2);
        this.nodes.sort((a,b) => Number(a.dataset.slot) - Number(b.dataset.slot));
        this.nodes.forEach(card => this.stage.append(card));
        this.busy = false;
        if (restoreFocus) this.nodes.find(card => card.dataset.slot === '0').focus({preventScroll:true});
      }, duration);
    }
    updateStatus(announce) {
      this.counter.textContent = `${this.index + 1} / ${this.total}`;
      if (announce) this.status.textContent = `${this.sources[this.index].dataset.title}, ${this.index + 1} de ${this.total}`;
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      clearTimeout(this.finishTimer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tokei-accessories-3d"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tokei-accessories')) {
  customElements.define('tokei-accessories', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.initTimer = setTimeout(() => this.init(), 0);
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.sourceList = this.querySelector('.tkacc__sources');
      if (!this.sourceList) return;
      this.sources = Array.from(this.sourceList.children);
      this.total = this.sources.length;
      if (!this.total) return;
      this.stage = this.querySelector('.tkacc__stage');
      this.controls = this.querySelector('.tkacc__controls');
      this.counter = this.querySelector('.tkacc__counter');
      this.status = this.querySelector('.tkacc__sr');
      this.index = 0;
      this.busy = false;
      this.controller = new AbortController();
      const opts = {signal: this.controller.signal};
      this.stage.replaceChildren();
      this.nodes = [];
      const slots = this.total === 1 ? [0] : [-2,-1,0,1,2];
      slots.forEach(slot => this.addCard(slot));
      this.sourceList.hidden = true;
      this.stage.hidden = false;
      this.controls.hidden = this.total < 2;
      this.updateStatus(false);
      this.controls.addEventListener('click', e => {
        const button = e.target.closest('[data-dir]');
        if (button) this.move(Number(button.dataset.dir));
      }, opts);
      this.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        this.move(e.key === 'ArrowRight' ? 1 : -1, this.stage.contains(document.activeElement));
      }, opts);
      this.stage.addEventListener('dragstart', e => e.preventDefault(), opts);
      this.stage.addEventListener('pointerdown', e => {
        if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
        this.start = {id:e.pointerId,x:e.clientX,y:e.clientY};
      }, opts);
      window.addEventListener('pointerup', e => {
        if (!this.start || this.start.id !== e.pointerId) return;
        const dx = e.clientX - this.start.x, dy = e.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) > 38 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.suppressClickUntil = Date.now() + 450;
          this.move(dx < 0 ? 1 : -1);
        }
      }, opts);
      window.addEventListener('pointercancel', () => { this.start = null; }, opts);
      this.stage.addEventListener('click', e => {
        if (Date.now() < (this.suppressClickUntil || 0) || this.busy) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, {...opts,capture:true});
    }
    wrap(n) { return (n % this.total + this.total) % this.total; }
    addCard(slot) {
      const card = this.sources[this.wrap(this.index + slot)].cloneNode(true);
      card.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.draggable = false; });
      this.stage.append(card);
      this.nodes.push(card);
      this.position(card, slot);
      return card;
    }
    position(card, slot) {
      card.dataset.slot = slot;
      const central = slot === 0;
      const visible = Math.abs(slot) < 2 && !(this.total === 2 && slot === -1);
      const scale = central ? 1 : .68;
      card.style.transform = `translateX(-50%) translateX(${slot * 59}%) scale(${scale})`;
      card.style.opacity = visible ? (central ? '1' : '.55') : '0';
      card.style.zIndex = central ? '3' : (visible ? '2' : '0');
      card.style.pointerEvents = visible ? 'auto' : 'none';
      card.inert = !visible;
      card.tabIndex = visible ? 0 : -1;
      card.setAttribute('aria-hidden', String(!visible));
    }
    move(direction, restoreFocus = false) {
      if (this.busy || this.total < 2) return;
      this.busy = true;
      this.index = this.wrap(this.index + direction);
      this.nodes.forEach(card => this.position(card, Number(card.dataset.slot) - direction));
      this.updateStatus(true);
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 480;
      this.finishTimer = setTimeout(() => {
        const obsolete = this.nodes.filter(card => Math.abs(Number(card.dataset.slot)) > 2);
        obsolete.forEach(card => card.remove());
        this.nodes = this.nodes.filter(card => !obsolete.includes(card));
        this.addCard(direction * 2);
        this.nodes.sort((a,b) => Number(a.dataset.slot) - Number(b.dataset.slot));
        this.nodes.forEach(card => this.stage.append(card));
        this.busy = false;
        if (restoreFocus) this.nodes.find(card => card.dataset.slot === '0').focus({preventScroll:true});
      }, duration);
    }
    updateStatus(announce) {
      this.counter.textContent = `${this.index + 1} / ${this.total}`;
      if (announce) this.status.textContent = `${this.sources[this.index].dataset.title}, ${this.index + 1} de ${this.total}`;
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      clearTimeout(this.finishTimer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
